<template>
  <el-dialog :visible="visible" width="1152px" append-to-body @update:visible="changeShow" @closed="closedDialog">
    <div slot="title" class="title">
      <span :title="data.title">{{data.title}}</span>
    </div>
    <div class="info_box">
      <div class="fx">
        <span class="fx-full source-text">发文机关：{{data.releaseOrganization}}</span>
        <span class="fx-none title-right source-text">{{data.releaseDate}}</span>
      </div>

      <div class="tag-panel mt-16" v-if="hasKeywords">
        <span>政策关键词：</span>
        <span class="policy-tag" v-for="item in (data||{}).tags" :key="item">{{item}}</span>
      </div>

      <div class="mt-16">政策原文：</div>
      <div class="mt-16 policy-text">
        <!-- formatText(data.policyText) -->
        <span v-html="data.rawContent"></span>
      </div>

      <el-link v-if="data.url" :href="data.url" class="mt-16" type="primary" target="_blank">查看原文</el-link>
    </div>
  </el-dialog>
</template>

<script>
import NewsTags from '@/views/industryChainNew/components/newsTags'
import popupMixin from '@/mixins/popup-mixin'
export default {
  name: 'DialogPolicyDetail',
  components: {
    NewsTags
  },
  mixins: [popupMixin],

  props: {
    data: {
      type: Object,
      default: () => ({})
    }

  },
  computed: {
    hasKeywords() {
      return this?.data?.tags?.length
    }
  },
  data() {
    return {

    }
  },
  methods: {
    formatText(text) {
      const reg = /(.*?)#&#/g
      text += '#&#'
      return text.replace(reg, (a, b) => {
        return `<p>${b}</p>`
      })
    },
    formatText2(text) {
      if (!text) return
      const reg = /src="http:\/\//g
      return text.replace(reg, (a, b) => {
        return 'src="https://'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.title-left {
  display: flex;
  flex: 1;
  align-items: center;
}
.title-text {
  color: inherit;
  max-width: calc(100% - 250px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 14px;
  text-decoration: none;
}
.tag-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  .policy-tag {
    font-size: 14px;
    font-weight: 400;
    color: #186bfc;
    background: rgba(24, 107, 252, 0.16);
    border-radius: 2px;
    padding: 4px 8px;
    margin-right: 8px;
    margin-top: 6px;
  }
}
.policy-text {
  max-height: 300px;
  overflow-y: auto;
}
</style>
